export default __webpack_public_path__ + "images/ffae4c7e26b41cefe08178b5e94abb76-fullscreen.svg";